// api/log.api.ts

import { PageLimit } from '@/components/TablePersonalizada';
import { axiosApi } from '@/config';
import { Log, LogsResponse, LogResponse, CreateLogRequest, UpdateLogRequest } from '../interfaces';
import { useAuthStore } from '@/modules/Login/store/auth.store';

/**
 * Buscar todos los logs con paginación y filtros
 */
export const searchLogs = async (params: PageLimit): Promise<LogsResponse> => {
	try {
		const response = await axiosApi.post('/log/search', params);
		return response.data;
	} catch (error) {
		console.error('Error fetching logs:', error);
		throw error;
	}
};

/**
 * Obtener un log por ID
 */
export const getLogById = async (id: string): Promise<Log> => {
	try {
		const response = await axiosApi.get(`/log/${id}`);
		return response.data;
	} catch (error) {
		console.error('Error fetching log:', error);
		throw error;
	}
};

/**
 * Crear un nuevo log
 */
const resolveUserId = (userId?: string) => {
	const resolvedId = userId ?? useAuthStore.getState().user?.id ?? null;
	if (!resolvedId) {
		throw new Error('No se pudo determinar el usuario autenticado para crear el log.');
	}
	return resolvedId;
};

export const createLog = async (logData: CreateLogRequest): Promise<LogResponse> => {
	try {
		const payload: CreateLogRequest = {
			...logData,
			userId: resolveUserId(logData.userId),
		};

		const response = await axiosApi.post('/log', payload);
		console.log('response', response.data);
		return response.data;
	} catch (error) {
		console.error('Error creating log:', error);
		throw error;
	}
};

/**
 * Actualizar un log
 */
export const updateLog = async (id: string, logData: UpdateLogRequest): Promise<LogResponse> => {
	try {
		const response = await axiosApi.patch(`/log/${id}`, logData);
		return response.data;
	} catch (error) {
		console.error('Error updating log:', error);
		throw error;
	}
};

/**
 * Eliminar un log
 */
export const deleteLog = async (id: string): Promise<{ message: string }> => {
	try {
		const response = await axiosApi.delete(`/log/${id}`);
		return response.data;
	} catch (error) {
		console.error('Error deleting log:', error);
		throw error;
	}
};

/**
 * Buscar logs por tabla específica
 * @param table Nombre de la tabla (ej: 'Invoice', 'Client', etc.)
 * @param params Parámetros de paginación
 */
export const searchLogsByTable = async (
	table: string,
	params: PageLimit,
): Promise<LogsResponse> => {
	try {
		const response = await axiosApi.post(`/log/table/${table}`, params);
		return response.data;
	} catch (error) {
		console.error('Error fetching logs by table:', error);
		throw error;
	}
};

/**
 * Buscar logs por tabla e idRegister específicos
 * @param table Nombre de la tabla (ej: 'Invoice', 'Client', etc.)
 * @param idRegister ID del registro
 * @param params Parámetros de paginación
 */
export const searchLogsByTableAndIdRegister = async (
	table: string,
	idRegister: string,
	params: PageLimit,
): Promise<LogsResponse> => {
	try {
		const response = await axiosApi.post(`/log/table/${table}/register/${idRegister}`, params);
		return response.data;
	} catch (error) {
		console.error('Error fetching logs by table and idRegister:', error);
		throw error;
	}
};
